import axios from 'axios';
import queryString from 'query-string';
import ConstCode from '@/common/constants/ConstCode';
import { debounce } from 'lodash';
import { useLayoutStore } from '@/store/modules/layout';
import { useAccountStore } from '@/store/modules/account';
import { toastAlert } from '@/common/utils/module/ToastSupport';
export * from '@/common/utils/module/ToastServiceResultSupport';

// const layoutStore = useLayoutStore();

const scrollIsLocked = (locked) => {
  document.getElementsByTagName('main')[0].style = `overflow:${locked ? 'hidden' : 'auto'}`;
};

const loading = () => {
  const layoutStore = useLayoutStore();
  layoutStore.isLoading = true;
  scrollIsLocked(true);
};
const loaded = debounce(() => {
  const layoutStore = useLayoutStore();
  layoutStore.isLoading = false;
  scrollIsLocked(false);
}, 500);

class ServiceExec {
  constructor() {
    let axiosInstance = axios.create();
    axiosInstance.interceptors.request.use(this.handleRequest);
    axiosInstance.interceptors.response.use(this.handleSuccess, this.handleError.bind(this));

    axiosInstance.defaults.paramsSerializer = function (params) {
      return queryString.stringify(params, {
        arrayFormat: 'repeat',
        allowDots: true
      });
    };
    this.ServiceExec = axiosInstance;
  }

  async handleRequest(request) {
    const accountStore = useAccountStore();
    loading();
    const accessToken = accountStore.accessToken;
    if (accessToken) {
      request.headers[ConstCode.LOGIN_TOKEN_NAME] = `${accessToken}`;
    }
    return request;
  }
  async handleSuccess(response) {
    loaded();
    return response;
  }
  async handleError({ response }) {
    loaded();
    if (this.status.UNAUTHORIZED === response.status) {
      toastAlert(response.data.message, 'error');
      setTimeout(() => location.replace('/'), 1000);
    } else return Promise.resolve(response);
  }

  status = {
    OK: 200,
    ERROR: 500,
    NOT_FOUND: 404,
    UNAUTHORIZED: 401
  };

  get(path, params = {}) {
    return this.ServiceExec.request({
      method: 'GET',
      url: path,
      responseType: 'json',
      params: params,
      paramsSerializer: (params) =>
        queryString.stringify(params, {
          arrayFormat: 'indices',
          skipEmptyString: true,
          skipNulls: true,
          allowDots: true
        })
    });
  }

  download(path, params = {}) {
    return this.ServiceExec.request({
      method: 'GET',
      url: path,
      responseType: 'blob',
      params: params,
      paramsSerializer: (params) =>
        queryString.stringify(params, {
          arrayFormat: 'indices',
          skipEmptyString: true,
          skipNulls: true,
          allowDots: true
        })
    });
  }

  put(path, payload) {
    return this.ServiceExec.request({
      method: 'PUT',
      url: path,
      responseType: 'json',
      data: payload
      // params: payload,
      // paramsSerializer: (payload) =>
      //   qs.stringify(payload, { arrayFormat: 'repeat' })
    });
  }
  patch(path, payload) {
    return this.ServiceExec.request({
      method: 'PATCH',
      url: path,
      responseType: 'json',
      data: payload
    });
  }
  post(path, payload) {
    return this.ServiceExec.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    });
  }
  put(path, payload) {
    return this.ServiceExec.request({
      method: 'PUT',
      url: path,
      responseType: 'json',
      data: payload
    });
  }
  delete(path, payload) {
    return this.ServiceExec.request({
      method: 'DELETE',
      url: path,
      responseType: 'json',
      data: payload
    });
  }

  postWithProgressBar(path, payload) {
    return this.ServiceExec.post(path, payload, {
      onUploadProgress: (progressEvent) => {
        const layoutStore = useLayoutStore();
        layoutStore.isProgressBar = true;

        let percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        layoutStore.progress = percentage;

        if (percentage >= 100) {
          const timeout = setTimeout(() => {
            clearTimeout(timeout);
            layoutStore.isProgressBar = false;
          }, 500);
        }
      },
      header: {
        'Response-Type': 'application/json'
      }
    });
  }

  getWithProgressBar(path, payload) {
    return this.ServiceExec.get(path, payload, {
      onUploadProgress: (progressEvent) => {
        const layoutStore = useLayoutStore();
        layoutStore.isProgressBar = true;

        let percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        layoutStore.progress = percentage;

        if (percentage >= 100) {
          const timeout = setTimeout(() => {
            clearTimeout(timeout);
            layoutStore.isProgressBar = false;
          }, 500);
        }
      },
      header: {
        'Response-Type': 'application/json'
      }
    });
  }

  queryPost(path, payload) {
    payload = `${queryString.stringify(payload)}`;
    return this.ServiceExec.request({
      method: 'POST',
      url: path,
      responseType: 'json',
      data: payload
    });
  }
  multipart(path, method, payload) {
    return this.ServiceExec.request({
      headers: { 'Content-Type': 'multipart/form-data' },
      method: method,
      url: path,
      responseType: 'json',
      data: payload
    });
  }
}

let instance;
const initialize = () => {
  if (!instance) instance = new ServiceExec();

  return instance;
};
export default initialize();
